/* eslint-disable no-undef */
import React, { useState, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';

import API from 'constants/api';
import LocaleContext from 'constants/localization';
import LocalizedStrings from 'react-localization';
import { SPECTRUM } from 'constants/predicates';

import LiteralEdit from 'field/edit/LiteralEdit';

// SPEC-1
// fetch generated primary number from API on load if no value
const PrimaryNumberEdit = ({ field }) => {
  // Could be used to temporarily disable input while loading
  // And display loading icon
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const LS = useContext(LocaleContext);
  localizedStrings.setLanguage(LS.getLanguage());

  const collection = useSelector(state => state.field.fields[SPECTRUM.ACQUISITION_COLLECTION]);
  const materialIdentifier = useSelector(state => state.field.fields[SPECTRUM.MATERIAL_ID]);
  const primaryNumberSpecifier = useSelector(state => state.field.fields[SPECTRUM.PRIMARY_NUMBER_SPECIFIER]);
  const uri = useSelector(state => state.object.uri) || '';
  useEffect(() => field.setDisabled(!collection || collection.values.length === 0), [collection]);
  
  useEffect(() => {
	  validateUniquePrimaryNumber(field.values[0]);
	  }, [primaryNumberSpecifier]);
  
  useEffect(() => {
	  validateUniquePrimaryNumber(field.values[0]);
	  }, [materialIdentifier]);
  
  const generatePrimaryNumber = () => {
    if (!loading) {
      setLoading(true);
      const urlParams = getUrlParams();
      fetch(`${API.IDENTIFIER}/primaryNumber?${urlParams.toString()}`)
        .then(res => res.json())
        .then(res => {
          const { primaryNumber, error } = res;

          if (primaryNumber) {
            field.setValue(0, primaryNumber);
            setError(null);
          } else if (error) {
            MetadataView.setError({ contents: error });
          }
          setLoading(false);
        })
        .catch(e => { console.log(e); setLoading(false); });
    }
  };

  const validateUniquePrimaryNumber = (number) => {
	 if (collection.values.length === 0 || !number || number === '') {
	    return;
	}
	// SPEC-607
	if(number > 2147483647){
		setError(`${localizedStrings.numberTooLarge}`);
		return;
	}
    const urlParams = getUrlParams();
    fetch(`${API.IDENTIFIER}/primaryNumber/isUnique?number=${number}&${urlParams.toString()}`)
      .then(res => res.json())
      .then(res => {
        const { error, isUnique } = res;
        if (!isUnique) {
          let numberString = number;
          if(primaryNumberSpecifier.values[0] != null && primaryNumberSpecifier.values[0] != ''){
        	  numberString = numberString+"_"+primaryNumberSpecifier.values[0];
          }
          setError(`${localizedStrings.notUnique} (${numberString})`);
        }
        else {
          setError(null);
        }
      })
      .catch(e => console.log(e));
  };

  const getUrlParams = () => {
	  // URIs are required for generation / checking uniqueness
	  // empty string in case not present
	  let collectionUri = '';
	  let materialIdUri = '';
	  let primaryNumberSpecifierValue = '';
	  
	  if (materialIdentifier != null && materialIdentifier.values.length > 0 && materialIdentifier.values[0].uri != null) {
	    materialIdUri = materialIdentifier.values[0].uri;
	  }
	  if (collection != null && collection.values.length > 0 && collection.values[0].uri != null) {
	    collectionUri = collection.values[0].uri;
	  }
	  if (primaryNumberSpecifier != null && primaryNumberSpecifier.values.length > 0 && primaryNumberSpecifier.values[0] != null) {
		  primaryNumberSpecifierValue = primaryNumberSpecifier.values[0];
      }
	  
	  const urlParams = new URLSearchParams({
	    subCollection: collectionUri,
	    materialIdentifier: materialIdUri,
	    acquisition: uri,
	    primaryNumberSpecifier: primaryNumberSpecifierValue
	  });
	  return urlParams;
  }
  
  return (
    <div className="field">
      {
        field.disabled && <p className="text-danger">{localizedStrings.collectionNotSelected}</p>
      }
      <button type="button" disabled={field.disabled} style={{marginBottom: '0.5rem'}} 
        onClick={generatePrimaryNumber}>
        {LS.actions.create} {LS.primaryNumber}
      </button>
      <LiteralEdit
        style={{ marginLeft: 0, paddingLeft: 0 }}
        validateInput={validateUniquePrimaryNumber}
        error={error}
        field={field} />
    </div>
  );
};

const localizedStrings = new LocalizedStrings({
  fi: {
    invalidFormat: 'Päänumero on väärässä muodossa',
    notUnique: 'Päänumero on jo käytössä',
    collectionNotSelected: 'Valitse kokoelma ensin',
    numberTooLarge: 'Numero on suurempi kuin sallittu maksimiarvo (2147483647)'
  },
  en: {
    invalidFormat: 'Primary number is in invalid format',
    notUnique: 'Primary number is already in use',
    collectionNotSelected: 'Please select Collection first',
    numberTooLarge: 'Number is larger than the allowed maximum value (2147483647)'
  }
});

export default PrimaryNumberEdit;